import { createBrowserRouter, createRoutesFromElements, Route, RouterProvider } from "react-router-dom";

import Theme from "Theme";
import Layout from "Layout";
import Container from "Layout/Container";

import Home from "Pages/Home";
import Services from "Pages/Services";
import Subscription from "Pages/Subscription";
import Request from "Pages/Request";
import Contact from "Pages/Contact";
import Download from "Pages/Download";
import HowToUse from "Pages/HowToUse";
import Register from "Pages/Register";
import Login from "Pages/Login";
import ForgotPassword from "Pages/ForgotPassword";
import ChangePassword from "Pages/ChangePassword";
import FAQ from "Pages/FAQ";
import Statistics from "Pages/Statistics";
import NotFound from "Pages/NotFound";

import ErrorBoundary from "Components/ErrorBoundary";

interface IRoute {
  path: string;
  element: JSX.Element;
  container?: boolean;
}

const routes: IRoute[] = [
  { path: "/", element: <Home /> },
  { path: "/services", element: <Services />, container: true },
  { path: "/subscription", element: <Subscription />, container: true },
  { path: "/request", element: <Request />, container: true },
  { path: "/contact-us", element: <Contact />, container: true },
  { path: "/download", element: <Download />, container: true },
  { path: "/how-to-use", element: <HowToUse />, container: true },
  { path: "/register", element: <Register />, container: true },
  { path: "/login", element: <Login />, container: true },
  { path: "/forgot-password", element: <ForgotPassword />, container: true },
  { path: "/change-password", element: <ChangePassword />, container: true },
  // { path: "/faq", element: <FAQ />, container: true },
  { path: "/a912a94d79b5124d876951f96ebb256f", element: <Statistics />, container: true },
  { path: "*", element: <NotFound />, container: true },
];

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route path="/" element={<Layout />}>
      {routes.map((route) => (
        <Route
          path={route.path}
          element={<>{route.container ? <Container>{route.element}</Container> : route.element}</>}
          errorElement={<ErrorBoundary />}
        />
      ))}
    </Route>
  )
);

function Router() {
  return (
    <Theme>
      <RouterProvider router={router} />
    </Theme>
  );
}

export default Router;
